export interface UI_AnchorProps {
	anchorName: string;
}

export const UI_Anchor: React.FC<UI_AnchorProps> = ({ anchorName }) => <a id={anchorName}></a>;
